/**
 * Helps normalize tier restriction data
 */

import { CacheableDataObject } from 'models/CacheableDataObject';
import { League } from "./League";

export default class TierRestriction extends CacheableDataObject {
	beforeConstruct() {
		this.tier_id = null;
		this.direction = null;
		this.ladder_id = null;
	}

	get tierId() {
		return this.tier_id;
	}

	set tierId(id) {
		this.tier_id = id;
	}

	get name_id() {
		return this.tier_id;
	}

	set name_id(id) {
		this.tier_id = id;
	}

	get ladderId() {
		return this.ladder_id;
	}

	set ladderId(id) {
		this.ladder_id = id;
	}

	canBeChallengedBy(league) {
		if(this.direction === 1) {
			if(this.isLessOrEqualTo(league)) {
				return true;
			}
		}
		if(this.direction <= -1) {
			if(this.isGreaterOrEqualTo(league)) {
				return true;
			}
			if(this.direction === -2) {
			}
		}
		return false;
	}

	getSummaryString() {
		let text = `${this.tier.name} ${this.division ? League.divisionNumberToRomanNumeral(this.division) + ' ' : ''}`;
		if(this.direction === 1) {
			text += 'and up can challenge this search';
		}
		if(this.direction === -1) {
			text += 'and below can challenge this search';
		}
		if(this.direction === -2) {
			text += 'and below (or unranked) can challenge this search';
		}
		return text;
	}

	isGreaterOrEqualTo(otherLeague) {
		if(!otherLeague) {
			return false;
		}
		if(this.tier.tier_rank > otherLeague.tier_rank) {
			return true;
		}
		if(this.tier.tier_rank === otherLeague.tier_rank) {
			return this.division <= otherLeague.division_number;
		}
		return false;
	}

	isLessOrEqualTo(otherLeague) {
		if(!otherLeague) {
			return true;
		}
		if(this.tier.tier_rank < otherLeague.tier_rank) {
			return true;
		}
		if(this.tier.tier_rank === otherLeague.tier_rank) {
			return this.division >= otherLeague.division_number;
		}
		return false;
	}

	static getLeagueFromRestriction(tierRestriction, ladder) {
		const season = ladder.getActiveSeason();
		const unrankedTier = season.getUnrankedTier();

		let currentDisplayedTier = null;
		let activeRestriction = null;
		if(_.isEmpty(tierRestriction) || tierRestriction.direction === 0) {
			activeRestriction = {
				direction: 0
			};
		}
		else {
			activeRestriction = tierRestriction;
		}
		if(!activeRestriction || activeRestriction.direction === 0) {
			currentDisplayedTier = unrankedTier;
		}
		else {
			currentDisplayedTier = season.tiers.find((tier) => {
				return tier.id === activeRestriction.tier_id;
			});
		}
		return currentDisplayedTier;
	}

	serialize() {
		return {
			tier_id: this.tier_id,
			direction: this.direction,
			ladder_id: this.ladder_id,
		};

	}

}


TierRestriction.prototype.dataLocationParsers = {
	name_id: (restriction, data) => {
		restriction.tier_id = data.name_id;
	},
	tierId: (restriction, data) => {
		restriction.tier_id = data.tierId;
	},
	division: (restriction, data) => {
		restriction.division = Number.isInteger(data.division) ? Number.parseInt(data.division) : null;
	},
	tier: (restriction, data) => {
		restriction.tier = new League(data.tier);
	}
};